import styled, { css } from 'styled-components'

import { outline } from 'components/Editor/styled/Outline'

import type { MediaStyles } from '../../types'

export const SliderStyled = styled.input`
  ${outline}
  position: relative;
  z-index: 1;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: transparent;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;

  &::-webkit-slider-thumb {
    width: 0;
    height: 0;
    -webkit-appearance: none;
  }
`

export const DisabledOverlay = styled.div<{ $left: number }>`
  position: absolute;
  top: -10px;
  bottom: -10px;
  right: 0;
  left: ${({ $left }) => `${$left * 100}%`};
  cursor: not-allowed;
  z-index: 2;
`

export const SliderWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const SliderTrack = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
  $preview?: boolean
}>`
  position: absolute;
  width: 100%;
  height: 4px;
  top: 50%;
  border-radius: 2px;
  background-color: var(--color-background-secondary);
  transform: translateY(-50%);
  pointer-events: none;
  overflow: hidden;

  ${({ $preview }) =>
    $preview &&
    css`
      background-color: var(--color-disabled);
    `}

  ${({ $styles }) =>
    $styles?.slider &&
    css`
      background-color: ${$styles.slider.backgroundColor || 'var(--color-background-secondary)'};
    `}
`

export const SliderLoaded = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
  $loaded: number
}>`
  position: absolute;
  height: 100%;
  background-color: var(--color-primary-default);
  opacity: 0.25;
  width: ${({ $loaded }) => `${$loaded * 100}%`};
  ${({ $styles }) =>
    $styles?.sliderFilled &&
    css`
      background-color: ${$styles.sliderFilled.backgroundColor || 'var(--color-primary-default)'};
    `}
`

export const SliderPlayed = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
  $played: number
}>`
  position: absolute;
  height: 100%;
  background-color: var(--color-primary-default);
  width: ${({ $played }) => `${$played * 100}%`};
  ${({ $styles }) =>
    $styles?.sliderFilled &&
    css`
      background-color: ${$styles.sliderFilled.backgroundColor || 'var(--color-primary-default)'};
    `}
`

export const PointsWrapperStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`

export const PointStyled = styled.div<{
  $styles?: Partial<Record<MediaStyles, React.CSSProperties>>
  $position: number // percentage position of the point
}>`
  position: absolute;
  width: 2px;
  height: 100%;
  transform: translateX(-50%);
  left: ${({ $position }) => `${$position}%`};
  ${({ $styles }) =>
    $styles?.player &&
    css`
      background-color: ${$styles.player.backgroundColor};
    `}
`
